import { globalStores } from '@/editor/stores';
import { IIntersectedModelEntityInfo } from '@/editor/types/entity';

export function isSelectAlignReferenceEntity(pickedEntityInfo: IIntersectedModelEntityInfo) {
  const { pendingEntities } = globalStores.editorStateStore.alignData;

  return (
    globalStores.editorStateStore.alignEnabled &&
    pendingEntities.some(({ entityId }) => entityId === pickedEntityInfo.entityId)
  );
}
